import TheGrid from './grid'

export default {
  path: '/campaigns/bestof/leader-results',
  redirect: '/campaigns/bestof/leader-results/index',
  name: 'bestof_leaderresults',
  meta: {
    auth: {
      redirect: {
        name: 'bestof_leaderresults.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bestof'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'bestof_leaderresults.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}
